<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head" id="fm01-001">DEDICATION</p>
<p class="txtt">With overwhelming gratitude, I dedicate this book to all the free spirits I have known in my life, especially those in the quilting community. I thank my mentors, who along the way have guided, encouraged, taught, and molded me, not just in this vocation but also throughout all the manifestations of my careers.</p>
<p class="txt">It all naturally started with my parents, without whom there would be no me. To my mother, who gave me that first box of crayons—and oh, glory, the day she bought the 96-count box with the sharpener! To my dad and brother, who taught me by example to work and work and work until it was <i>right</i>, not just complete.</p>
<p class="txt">To Grandma Elsie, without whom I would never have had the courage to question or even to try to fly.</p>
<p class="txt">To my children, Colin and Dana, for the joy and light they shine into my world, and for whom I push on every day, wanting to show them that obstacles are there to be overcome.</p>
<p class="txt">To my husband, Gerry, for his love, patience, support, and guidance, especially when things seemed overwhelming and the end was so far out of sight.</p>
<p class="txt">Thank you to all of you for believing in me when I sometimes didn’t. I am the sum of so many things, and you each bring a color to my crayon box that is unique to you—one I would never want to be without.</p>
<p class="figt"><img alt="" src="images/pg4_1.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_dedication.vue?f4e5c626